export interface ContactInternalInfoDTO {
  contactId?: string;
  extension?: number;
}
